import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';

export interface StatBox {
  labelKey: string;
  value: number | string;
  colorVar: string;
}

@Component({
  selector: 'app-stat-card',
  imports: [TranslatePipe, SectionTitleComponent],
  templateUrl: './stat-card.component.html',
  styleUrl: './stat-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatCardComponent {
  titleKey = input.required<string>();
  subtitleKey = input.required<string>();
  stats = input.required<StatBox[]>();
  sectionLabelKey = input<string | null>(null);
  statAriaKey = input<string | null>(null);

  protected readonly titleId = `stat-card-title-${crypto.randomUUID()}`;
}
